import React from 'react'
import Axios from 'axios'
import * as Constants from '../../../assets/helpers/constants'
import LoaderComp from '../../Loader'
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2'
import Moment from 'react-moment';
import fileDownload from 'js-file-download'

import '../../../assets/css/FileManager.css'

import trashCan from '../../../assets/images/trash.png'
import uploadNewFolder from '../../../assets/images/AddUp.png'
import uploadIcon from '../../../assets/images/UploadUp.png'
import dropdownImg from '../../../assets/images/Untitled-1-10.png'

import jpgIcon from '../../../assets/images/Group 498@2x.png'
import pngIcon from '../../../assets/images/Group 500@2x.png'
import pdfIcon from '../../../assets/images/Group 499@2x.png'
import xmlIcon from '../../../assets/images/Group 502@2x.png'

import expIcon from '../../../assets/images/Group 497@2x.png'
import mp4Icon from '../../../assets/images/Group 504@2x.png'
import flvIcon from '../../../assets/images/Group 495@2x.png'
import mp3Icon from '../../../assets/images/Group 501@2x.png'
import gifIcon from '../../../assets/images/Group 520@2x.png'
import folderIcon from '../../../assets/images/folder.png'


class FileManager extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultCompany: "Select Company",
            isLoading: false,
            location: null,
            Experiences: [],
            CompanyList: [],
            selectedFiles: [],
            companyName: "",
            companyId: null,
            jpegFiles: this.props.details.jpegFiles,
            pngFiles: this.props.details.pngFiles,
            pdfFiles: this.props.details.pdfFiles,
            xmlFiles: this.props.details.xmlFiles,
            foldersFiles: this.props.details.foldersFiles,
            otherFormats: this.props.details.otherFormats,
            breadCrumb: null,
            breadCrumbLength: 0,
            initialName: "",
            finalName: "",
            file: null,
            columns: [
                {
                    name: 'Type',
                    grow: 1,
                    center: 1,
                    cell: (row, index) => {
                        let Filetype = row.type
                        let iconValue = null
                        if (Filetype === "Folder") {
                            iconValue = <img src={folderIcon} alt="folderIcon" />
                        } else if (Filetype === ".png" || Filetype === ".PNG") {
                            iconValue = <img src={pngIcon} alt="pngIcon" />
                        } else if (Filetype === ".pdf" || Filetype === ".PDF") {
                            iconValue = <img src={pdfIcon} alt="pdfIcon" />
                        } else if (Filetype === ".xml" || Filetype === ".XML") {
                            iconValue = <img src={xmlIcon} alt="xmlIcon" />
                        } else if (Filetype === ".jpg" || Filetype === ".JPG") {
                            iconValue = <img src={jpgIcon} alt="jpgIcon" />
                        } else if (Filetype === ".exp" || Filetype === ".EXP") {
                            iconValue = <img src={expIcon} alt="expIcon" />
                        } else if (Filetype === ".mp4" || Filetype === ".MP4") {
                            iconValue = <img src={mp4Icon} alt="mp4Icon" />
                        } else if (Filetype === ".mp3" || Filetype === ".MP3") {
                            iconValue = <img src={mp3Icon} alt="mp3Icon" />
                        } else if (Filetype === ".flv" || Filetype === ".FLV") {
                            iconValue = <img src={flvIcon} alt="flvIcon" />
                        } else if (Filetype === ".gif" || Filetype === ".GIF") {
                            iconValue = <img src={gifIcon} alt="flvIcon" />
                        }
                        
                        return (<div data-tag="allowRowEvents" className="osIcon text-left" onClick={Filetype === "Folder" ? () => this.navigateFolder(row.name) : () => this.previewFile(row.name)}>{iconValue}
                        </div>)
                    },
                    selector: 'type',
                    sortable: true
                },
                {
                    name: 'Name ',
                    grow: 3,
                    center: 1,
                    cell: (row, index) => <div data-tag="allowRowEvents" key={index}>
                        <p onDoubleClick={(e) => this.handleDoubleClick(row.name, row.type)}>{row.name}</p>
                    </div >
                    ,
                    selector: 'name',
                    sortable: true
                },
                {
                    name: 'Date Modified',
                    grow: 2,
                    center: 1,
                    cell: row => <div data-tag="allowRowEvents" className="devicesStatus text-left">
                        <Moment format="DD-MM-YYYY hh:mm">
                            {row.timeStamp}
                        </Moment>
                    </div>,
                    selector: 'timeStamp',
                    sortable: true
                },

                {
                    name: 'Size',
                    grow: 1,
                    center: 1,
                    cell: row => <div data-tag="allowRowEvents" className="devicesExpName text-left">{row.type !== "Folder" ? this.formatBytes(row.size) : null}</div>,
                    selector: 'size',
                    sortable: true
                },
                {
                    name: 'Action',
                    grow: 2,
                    center: 1,
                    cell: row => <div data-tag="allowRowEvents" className="devicesTagName text-center">
                        {row.type === "Folder" ? <button type="button" className="view" onClick={() => this.navigateFolder(row.name)} ><b>View</b></button> : <button type="button" className="preview" onClick={() => this.previewFile(row.name)} ><b>Preview</b></button>}
                        <button type="button" className="download" onClick={() => this.downloadFile(row.name, row.type)}><b>Download</b></button>
                    </div>,
                    sortable: false
                }
            ]
        }
    }

    componentDidMount() {
        if (this.props.UserInfo !== undefined) {
            let CompanyName = JSON.parse(localStorage.getItem("userDetails"))[0].CompanyName
            let CompanyId = JSON.parse(localStorage.getItem("userDetails"))[0].CompanyId
            let userID = JSON.parse(localStorage.getItem("userDetails"))[0].UserID
            this.getCompanyDetails(CompanyId, CompanyName, userID)
            this.props.getFileManagerFolderDetails(CompanyName)
        } else {
            this.props.history.push(Constants.Login)
        }
    }

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    getCompanyDetails = (CompanyId, CompanyName, userID) => {
        this.setState({
            isLoading: true
        }, () => {

            let role = JSON.parse(localStorage.getItem("userDetails"))[0].Role
            if (role === Constants.ContentManager || role === Constants.ComposerUser) {
                this.setState({
                    CompanyList: [{
                        CompanyId: CompanyId,
                        CompanyName: CompanyName
                    }],
                    companyId: CompanyId,
                    companyName: CompanyName,
                    defaultCompany: CompanyName + "_" + CompanyId,
                    location: CompanyName,
                    breadCrumb: CompanyName,
                    breadCrumbLength: 1,
                    isLoading: false
                })
            } else {
                Axios.get(Constants.BASE_URL + `api/ExperienceManagement/getCompaniesList/${userID}/${CompanyId}`).then((result) => {
                    if (result.data.status) {
                        this.setState({
                            CompanyList: result.data.info.filter((ele, ind) => ind === result.data.info.findIndex(elem => elem.CompanyId === ele.CompanyId)),
                            companyId: CompanyId,
                            companyName: CompanyName,
                            defaultCompany: CompanyName + "_" + CompanyId,
                            location: CompanyName,
                            breadCrumb: CompanyName,
                            breadCrumbLength: 1,
                            isLoading: false
                        })
                    }
                })
            }
        })
    }

    navigateFolder = (folderName) => {
        let location = this.state.location + "/" + folderName
        let locationSplit = location.split("/")
        var x = locationSplit.join("/")
        this.setState({
            location: this.state.location + "/" + folderName,
            breadCrumb: x,
            breadCrumbLength: locationSplit.length,
            files: []
        })
        this.props.history.push(Constants.FileManager)
        this.props.getFileManagerFolderDetails(this.state.location + "/" + folderName)
    }

    navback = () => {
        let currentLocation = this.state.location;
        let locationSplit = currentLocation.split("/")
        if (locationSplit.length <= 1) {
            this.props.history.push(Constants.FileManager)
        } else {
            locationSplit.pop()
            let finalLocation = locationSplit.join("/")
            var x = locationSplit.join("/")
            this.setState({
                location: finalLocation,
                breadCrumb: x,
                breadCrumbLength: locationSplit.length,
                files: []
            })
            this.props.history.push(Constants.FileManager)
            this.props.getFileManagerFolderDetails(finalLocation)
        }
    }

    addNewFolder = () => {
        Swal.fire({
            title: 'Create New Folder',
            input: 'text',
            inputValue: "",
            showCancelButton: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Please enter the name of folder!'
                } else {
                    if (!/[^a-zA-Z0-9]/.test(value)) {
                        if (value.length > 30) {
                            return 'Should not contain more than 30 characters'
                        } else {
                            this.createFolder(value)
                        }
                    } else {
                        return 'Should not contain spaces or Special Characters'
                    }
                }
            }
        })
    }

    createFolder = (value) => {
        this.setState({
            isLoading: true
        }, () => {
            let data = {
                "location": this.state.location + "/" + value
            }
            Axios.post(Constants.BASE_URL + 'api/mediaManagement/checkCompanyExists', data).then((result) => {
                if (result.data.status) {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Folder Created Sucessfully",
                        showConfirmButton: false,
                        timer: 1000
                    })
                    this.props.getFileManagerFolderDetails(this.state.location)
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: result.data.info,
                        showConfirmButton: false,
                        timer: 1000
                    })
                }
                this.setState({
                    isLoading: false
                })
            })
        })
    }

    changeCompany = (e) => {
        this.setState({
            companyId: e.target.id,
            companyName: e.target.value,
            location: e.target.value,
            breadCrumb: e.target.value,
            breadCrumbLength: 1
        })
        this.props.getFileManagerFolderDetails(e.target.value)
    }

    handleDoubleClick = (e, type) => {
        this.setState({
            initialName: e,
            finalName: e
        }, () => {
            this.renameFolderValue(type)
        })
    }

    renameFolderValue = (type) => {
        let title = ""
        if (type === "Folder") {
            title = "Rename Folder"
        } else {
            title = "Rename File"
        }
        Swal.fire({
            title: title,
            input: 'text',
            inputValue: this.state.initialName,
            showCancelButton: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Please enter the name of folder!'
                } else {
                    if (type === "Folder") {
                        if (!/[^a-zA-Z0-9]/.test(value)) {
                            this.renameFolder(value, type)
                        } else {
                            return 'Should not contain spaces or Special Characters'
                        }
                    } else {
                        this.renameFolder(value, type)
                    }
                }
            }
        })
    }

    renameFolder = (newValue, type) => {
        this.setState({
            isLoading: true
        }, () => {
            let data = {
                "currentName": this.state.initialName,
                "finalName": newValue,
                "companyName": this.state.location,
                "type": type === "Folder" ? "Folder" : "File"
            }

            Axios.post(Constants.BASE_URL + 'api/mediaManagement/renameFolder', data).then((result) => {
                if (result.data.status) {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Folder Name Updated Successfully!!",
                        showConfirmButton: false,
                        timer: 1000
                    })
                    this.props.getFileManagerFolderDetails(this.state.location)
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: "Unable to rename file. Please contact Admin!!",
                        showConfirmButton: false,
                        timer: 1000
                    })
                }
                this.setState({
                    isLoading: false
                })
            })
        })
    }

    uploadFiles = () => {
        let data = {
            location: this.state.location,
            userId: JSON.parse(localStorage.getItem("userDetails"))[0].UserID,
            companyId: this.state.companyId
        }
        localStorage["details"] = JSON.stringify(data)
        this.props.history.push(Constants.UploadFiles)
    }

    fileupload = (e) => {
        this.setState({
            file: e.target.files
        }, () => {
            document.getElementById("submitFilesbtn").click()
        })
    }

    selectedFiles = (details) => {
        if (details.selectedCount > 0) {
            var array = []
            details.selectedRows.forEach(element => {
                var id = element.name;
                var type = element.type;
                var obj = {
                    id: id,
                    type: type
                }
                array.push(obj);
            })
            this.setState({
                selectedFiles: array
            });
        } else {
            this.setState({
                selectedFiles: []
            });
        }
    }

    deleteFiles = () => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            text: "You won't be able to revert this!",
            icon: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    isLoading: true
                }, () => {
                    let data = {
                        files: this.state.selectedFiles,
                        location: this.state.location,
                        userId: JSON.parse(localStorage.getItem("userDetails"))[0].UserID
                    }
                    Axios.post(Constants.BASE_URL + "api/mediaManagement/deleteMedia", data).then((result) => {
                        if (result.data.status) {
                            Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: "Files Deleted Successfully",
                                showConfirmButton: false,
                                timer: 1000
                            })
                            this.setState({
                                isLoading: false,
                                selectedFiles: []
                            })
                            this.props.history.push(Constants.FileManager)
                            this.props.getFileManagerFolderDetails(this.state.location)
                        } else {
                            Swal.fire({
                                position: 'top-end',
                                icon: 'error',
                                title: "Unable to delete Files. Please try again!!",
                                showConfirmButton: false,
                                timer: 1000
                            })
                            this.setState({
                                isLoading: false,
                                selectedFiles: []
                            })
                        }
                    });
                })
            }
        })
    }

    downloadFile = (name, type) => {
        this.setState({
            isLoading: true
        }, () => {
            let data = {
                name: name,
                location: this.state.breadCrumb,
                breadCrumbLength: this.state.breadCrumb.split("/").length
            }
            Axios.post(Constants.BASE_URL + "api/mediaManagement/downloadMedia", data, {
                responseType: 'blob',
            })
                .then((res) => {
                    if (type === "Folder") {
                        fileDownload(res.data, name + ".zip")
                        Axios.post(Constants.BASE_URL + "api/mediaManagement/deleteZipFolderMedia", data)
                            .then((response) => {
                                if (response.status) {
                                    this.setState({
                                        isLoading: false
                                    }, () => {
                                        Swal.fire({
                                            position: 'top-end',
                                            icon: 'success',
                                            title: "File Downloaded Sucessfully",
                                            showConfirmButton: false,
                                            timer: 1000
                                        })
                                    })
                                } else {
                                    this.setState({
                                        isLoading: false
                                    }, () => {
                                        Swal.fire({
                                            position: 'top-end',
                                            icon: 'success',
                                            title: "Error in Downloading the File. Contact Admin!!",
                                            showConfirmButton: false,
                                            timer: 1000
                                        })
                                    })
                                }

                            })
                    } else {
                        this.setState({
                            isLoading: false
                        }, () => {
                            fileDownload(res.data, name)
                        })
                    }
                })

        })
    }

    previewFile = (name) => {
        let obj = {
            location: this.state.location,
            file: name
        }
        this.props.history.push(Constants.PreviewFile + "/[" + JSON.stringify(obj) + "]")
    }

    render() {
        return (
            <div className="fileManager" >
                {this.state.isLoading ? (<LoaderComp isLoading={this.state.isLoading} />) : null}
                <div className="row" >
                    <div className="col-12 activityLogDiv">
                        <p className="ActivityLogTitle pt-3 ">File Management</p>
                        <div className="actionDiv"></div>
                        <hr className="mt-0" />
                    </div>
                </div>
                <div className="row m-0 mt-2 mb-2">
                    <div className="col-12 m-0 ">
                        <div className="row ">
                            <div className="col-12">
                                <label className="companyDetails">
                                    <span className="selectdiv">Company
                                        <select onChange={this.changeCompany} value={this.state.companyName} placeholder="Select Company">
                                            {this.state.CompanyList.length > 0 ? (this.state.CompanyList.map((company, index) => {
                                                return <option key={index} id={company.CompanyId} value={company.CompanyName}>{company.CompanyName}</option>
                                            })
                                            )
                                                : null}
                                        </select>
                                    </span>
                                    <span className="searchDiv">
                                        <i className="fa fa-search" aria-hidden="true"> </i><span>|</span>
                                        <input type="text" placeholder="Search keyword" onChange={(e) => this.props.searchMedia(e.target.value)} />
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row fileslistNavBar  filesList">
                    <div className="col-12 whiteBacground">
                        <div className="row">
                            <div className="col-4 text-left">
                                {this.state.breadCrumbLength > 1 ? (<label className="backbutton" onClick={this.navback}> <span><img src={dropdownImg} alt="backbutton" /></span>BACK  {(this.state.breadCrumb !== "" && this.state.breadCrumb !== null) ? <span>( {this.state.breadCrumb})</span> : null} </label>) : null}
                            </div>
                            <div className="col-8">
                                <label className="uploadNewFiles"><span><img src={uploadIcon} alt="uploadNewFiles" /></span><button onClick={this.uploadFiles}>Upload New Files</button></label>
                                <label className="uploadNewFiles addNewFolder"><span><img src={uploadNewFolder} alt="addFolder" /></span><button onClick={this.addNewFolder}>Add New Folder</button></label>
                                {this.state.selectedFiles.length > 0 ? (<label className="uploadNewFiles deleteFiles"><span><img src={trashCan} alt="DeleteFiles" /></span><button onClick={this.deleteFiles}>Delete Files</button></label>) : null}
                                <form id="uploadFiles" onSubmit={this.submitFiles}>
                                    <input type="file" onChange={this.fileupload} id="FileUpload1" multiple style={{ display: 'none' }} />
                                    <input type="button" id="submitFilesbtn" onClick={this.submitFiles} style={{ display: 'none' }} />
                                </form>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="filesListTable">
                                    {this.props.details.filteredFiles.length > 0 ?
                                        <DataTable
                                            columns={this.state.columns}
                                            data={this.props.details.filteredFiles}
                                            selectableRows={true}
                                            progressPending={this.props.details.filteredFiles.length > 0 ? false : true}
                                            pagination={true}
                                            onSelectedRowsChange={this.selectedFiles}
                                        /> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default FileManager